import { gql } from "lib/apolloClient";

export const unmarkStudentsFragment = {
  unmarkStudentsDetails: gql`
    fragment unmarkStudentsDetails on Student {
      id
      firstName
      lastName
      middleName
      preferredName
      prefix
      suffix
      pronouns
      type
    }
  `,
};

export const studentNameFragment = {
  studentNameFields: gql`
    fragment studentNameFields on Student {
      firstName
      middleName
      lastName
      preferredName
      prefix
      suffix
      pronouns
      type
    }
  `,
};

export const familyMemberNameFragment = {
  familyMemberNameFields: gql`
    fragment familyMemberNameFields on FamilyMember {
      firstName
      middleName
      lastName
      preferredName
      prefix
      suffix
      pronouns
      type
    }
  `,
};

export const staffNameFragment = {
  staffNameFields: gql`
    fragment staffNameFields on Staff {
      firstName
      middleName
      lastName
      preferredName
      prefix
      suffix
      pronouns
      type
    }
  `,
};

export const parentNameFragment = {
  parentNameFields: gql`
    fragment parentNameFields on Parent {
      firstName
      middleName
      lastName
      preferredName
      prefix
      suffix
      pronouns
      type
    }
  `,
};
